var map = {
	"./aldo.png": 2765,
	"./aliexpress.png": 7214,
	"./alsaadhome.png": 6636,
	"./amazon.png": 1493,
	"./asos.png": 9371,
	"./babyshop.png": 197,
	"./basharacare.png": 7910,
	"./bathandbody.png": 5135,
	"./boots.png": 9590,
	"./boutiqaat.png": 9167,
	"./brandsforless.png": 7425,
	"./carrefour.png": 8724,
	"./centrepoint.png": 740,
	"./chicpoint.png": 460,
	"./cider.png": 9696,
	"./crocs.png": 4381,
	"./danubehome.png": 1053,
	"./desertcart.png": 5964,
	"./doduae.png": 993,
	"./dyson.png": 5798,
	"./eyewa.png": 2270,
	"./farfetch.png": 3032,
	"./firstcry.png": 8979,
	"./fordeal.png": 4394,
	"./groupon.png": 339,
	"./handm.png": 5257,
	"./hibobi.png": 8326,
	"./homebox.png": 3037,
	"./homecentre.png": 6321,
	"./homesrus.png": 4527,
	"./hudabeauty.png": 6465,
	"./iherb.png": 9721,
	"./letstango.png": 5144,
	"./levelshoes.png": 6267,
	"./lifepharmacy.png": 908,
	"./lightinthebox.png": 2400,
	"./lulushopping.png": 2953,
	"./maxfashion.png": 5107,
	"./modanisa.png": 7731,
	"./mumzworld.png": 7404,
	"./namshi.png": 6903,
	"./next.png": 3390,
	"./nike.png": 6330,
	"./noon.png": 2431,
	"./ounass.png": 3112,
	"./ourshopee.png": 5465,
	"./puma.png": 1790,
	"./randbfashion.png": 4970,
	"./sephora.png": 293,
	"./sharafdg.png": 6395,
	"./shein.png": 9970,
	"./sivvi.png": 4992,
	"./sixthstreet.png": 988,
	"./smartbuyglasses.png": 538,
	"./splashonline.png": 6270,
	"./storeus.png": 8818,
	"./styli.png": 2034,
	"./sunandsandsports.png": 363,
	"./temu.png": 9409,
	"./toysrus.png": 8210,
	"./trendyol.png": 1278,
	"./underarmour.png": 6787,
	"./vogacloset.png": 7752,
	"./wish.png": 7240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6734;